// extracted by mini-css-extract-plugin
export var readonly = "_gy-1";
export var star = "_gy-0";